/**
 * InsurerDetailPage — fiche assureur (9.V.2b) : identité + statut + carnet de
 * contacts. Le CRUD structurel de l'assureur (renommer, activer) reste 9.V.1 —
 * ici lecture de l'entête + gestion des contacts/emails.
 */

import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

import { useInsurer } from "../../lib/queries/insurers";

import { InsurerContactsSection } from "./_parts/InsurerContactsSection";

export function InsurerDetailPage() {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const { data: insurer, isLoading, isError } = useInsurer(id);

  return (
    <div className="mx-auto max-w-4xl px-4 py-6">
      <Link
        to="/insurers"
        className="text-brand-700 focus-visible:ring-brand-500 mb-4 inline-flex rounded text-sm font-medium hover:underline focus-visible:outline-none focus-visible:ring-2"
      >
        ← {t("insurers.back_to_list")}
      </Link>

      {isLoading ? (
        <p className="py-8 text-sm text-slate-500">{t("app.loading")}</p>
      ) : isError || !insurer ? (
        <p role="alert" className="py-8 text-sm text-red-700">
          {t("insurers.detail.not_found")}
        </p>
      ) : (
        <>
          <header className="mb-6 flex flex-wrap items-center gap-x-3 gap-y-1">
            <h1 className="text-3xl font-semibold tracking-tight text-slate-900">{insurer.name}</h1>
            <span className="font-mono text-sm text-slate-500">{insurer.code}</span>
            <span
              className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset ${
                insurer.status === "active"
                  ? "bg-emerald-50 text-emerald-700 ring-emerald-200"
                  : "bg-slate-100 text-slate-600 ring-slate-200"
              }`}
            >
              {t(`insurers.status.${insurer.status}`)}
            </span>
          </header>

          <InsurerContactsSection
            insurerId={insurer.id}
            insurerActive={insurer.status === "active"}
          />
        </>
      )}
    </div>
  );
}
